const util = {
    getViewport: () => window.innerWidth
};

export default util;